import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { connect } from 'react-redux';

import MiniOffer from './MiniOffer';
import { offer } from '../../../services/api';
import { OfferFormTitle } from '../../Common';

const Container = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  width: 80%;
  min-height: 250px;
`;

const Loading = styled.div`
  padding-top: 70px;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;

interface Props {
  business?: any;
}

interface State {
  data: Array<Offer>;
  loaded: boolean;
}

class PreviousOffers extends React.Component<Props, State> {
  state: State = { data: [], loaded: false };

  constructor(props) {
    super(props);
    offer.getOldOffers(this.props.business && this.props.business.business_id).then((result) => {
      const data = result.data.sort((a, b) =>
        moment(a.starts_at).isAfter(moment(b.starts_at)) ? -1 : 1
      );
      this.setState({ data, loaded: true });
    });
  }

  render() {
    let show: JSX.Element | Array<JSX.Element>;
    if (!this.state.data.length && this.state.loaded) show = <div>No previous offers</div>;
    else if (!this.state.data.length) {
      show = (
        <Loading>
          <img src="https://ubisafe.org/images/transparent-gif-spinner-1.gif" width="20" alt="" />{' '}
          Loading previous offers...
        </Loading>
      );
    } else show = this.state.data.map((item) => <MiniOffer offer={item} key={item.id} />);

    return (
      <>
        <OfferFormTitle>CREATE FROM PREVIOUS OFFER</OfferFormTitle>
        <Container>
          <br />
          <ImageContainer>{show}</ImageContainer>
        </Container>
      </>
    );
  }
}

export default connect(({ business }: any) => ({ business }), null)(PreviousOffers);
